import { useState } from 'react'
import {
  FolderOpen,
  Link2,
  Inbox,
  Calendar,
} from 'lucide-react'
import DocumentIngestion from '@/components/documents/DocumentIngestion'
import LiveDocumentVault from '@/components/documents/LiveDocumentVault'
import CloudStorageTab from '@/components/documents/CloudStorageTab'
import ReportAutomation from '@/components/documents/ReportAutomation'
// ── Types ──────────────────────────────────────────────────────────────────


// ── Component ──────────────────────────────────────────────────────────────
type DocVaultTab = 'vault' | 'inbox' | 'reports' | 'cloud'

export default function DocumentVault() {
  const [activeTab, setActiveTab] = useState<DocVaultTab>('vault')

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex-1 overflow-hidden flex flex-col p-4 space-y-3">
        {/* ── Tab Bar ─────────────────────────────────────────────────── */}
        <div className="flex items-center gap-1 border-b border-amber-400/10">
          {([
            { id: 'vault' as const, label: 'Document Vault', icon: <FolderOpen size={12} /> },
            { id: 'inbox' as const, label: 'Inbox & Extraction', icon: <Inbox size={12} /> },
            { id: 'reports' as const, label: 'Report Automation', icon: <Calendar size={12} /> },
            { id: 'cloud' as const, label: 'Cloud Storage', icon: <Link2 size={12} /> },
          ]).map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-1.5 px-3 py-2 text-[11px] font-medium border-b-2 transition-all ${
                activeTab === tab.id
                  ? 'border-amber-400 text-amber-300'
                  : 'border-transparent text-stone-500 hover:text-stone-300'
              }`}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>

        {/* The vault reads the server, which files every ingested email and
            attachment under its deal as it arrives. The folder tree this
            replaced was rendered from a demo constant of six fictional files
            while the real ones sat unfiled on their ingestions. */}
        {activeTab === 'vault' && <LiveDocumentVault />}
        {activeTab === 'inbox' && <DocumentIngestion />}
        {activeTab === 'reports' && <ReportAutomation />}

        {/* The cloud tab reads real connections. What it replaced was a
            hardcoded list of two providers marked connected, with invented
            sync times and a cross-source table of fictional deals. */}
        {activeTab === 'cloud' && <CloudStorageTab />}

      </div>
    </div>
  )
}
